import { FormErrors } from "redux-form"
import { ValidationGenerator } from "../../../../../form/validation/validation-generator"
import { SurveyValidationSetting } from "../../../../../form/validation/validation-setting"
import { ICreateScaleSurveyProps } from "./index"

export const validate = (values: ICreateScaleSurveyProps) => {
  const errors: FormErrors<ICreateScaleSurveyProps> = {}

  const titleVal = ValidationGenerator(
    values.title,
    SurveyValidationSetting.title,
  )
  if (titleVal) {
    errors.title = titleVal
  }

  return errors
}
